import { useNavigate } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'

import { useEffect } from 'react'
import { ErrorLayout } from './ErrorLayout'
import NO_LOCATION from './assets/no_location.png'
import { NoLocationImage } from './styles'
import { ErrorComponentProps } from './types'

export const NoTargetLocation = ({ CustomContainer, analyticEventsLabel }: ErrorComponentProps) => {
  const navigate = useNavigate()

  useEffect(() => {
    trackInternalEvent('show_missing_error', {
      label: analyticEventsLabel,
      missing_info: 'target_location',
    })
  }, [analyticEventsLabel])

  return (
    <ErrorLayout
      CustomContainer={CustomContainer}
      Images={<NoLocationImage src={NO_LOCATION} alt="no_location" />}
      translationKey="no_target_location"
      onClick={() => {
        trackInternalEvent('view_profile_editor', { label: 'recommended_jobs' })
        navigate(
          '/career-profile/edit?section=jobPreferences&returnUrl=/job-search?view=recommendation',
        )
      }}
    />
  )
}
